import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  selectField: {
    marginTop: 8,
    marginBottom: 8,
    width: '100%',
  },
}))
